(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };

  ready(() => {
    document.querySelectorAll('[data-landing-tabs]').forEach((section) => {
      const tabs = Array.from(section.querySelectorAll('[data-featured-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-featured-panel]'));
      const cta = section.querySelector('[data-featured-cta]');

      const activate = (targetId) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.featuredTab === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.featuredPanel === targetId);
        });
      };

      const updateCTA = (tab) => {
        if (!cta || !tab) return;
        const link = tab.dataset.featuredLink;
        const name = tab.dataset.featuredName || '';
        if (link) {
          cta.href = link;
        }
        if (cta.dataset.featuredDefault) {
          cta.textContent = `${cta.dataset.featuredDefault} ${name}`.trim();
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activate(tab.dataset.featuredTab);
          updateCTA(tab);
        });
      });

      if (tabs.length) {
        const current = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        activate(current.dataset.featuredTab);
        updateCTA(current);
      }
    });

    document.querySelectorAll('[data-order-form]').forEach((form) => {
      const input = form.querySelector('input');
      const error = form.querySelector('[data-order-error]');
      const base = form.dataset.orderBase || '';

      const clearError = () => {
        if (error) {
          error.textContent = '';
          error.setAttribute('hidden', 'hidden');
        }
      };

      input?.addEventListener('input', () => clearError());

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const raw = (input?.value || '').replace(/\D/g, '');
        if (/^\d{13}$/.test(raw) && base) {
          window.location.href = `${base}${raw}`;
        } else if (error) {
          error.textContent = form.dataset.orderError || 'Enter a valid order ID';
          error.removeAttribute('hidden');
        }
      });
    });
  });
})();
